import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CodeMirror from "@uiw/react-codemirror";
import { python } from "@codemirror/lang-python";

import api from "./../api";

export default function CodeEditorModal({ name, onClose }) {
  const [code, setCode] = useState("");
  const [packages, setPackages] = useState("");
  const [log, setLog] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get(`/api/generators/${name}/code`)
      .then((d) => {
        setCode(d.code || "");
        setPackages((d.venv_packages || []).join(" "));
        setLog(d.venv_log || "");
      })
      .catch(() => {});
  }, [name]);

  const save = async (reprovision) => {
    setBusy(true);
    try {
      await api.patch(`/api/generators/${name}`, {
        code,
        venv_packages: packages.split(/\s+/).filter(Boolean),
        reprovision: !!reprovision,
      });
      toast.success(reprovision ? "Saved + rebuilding venv" : "Saved");
      onClose(true, !!reprovision);
    } catch {
      /* api wrapper toasts */
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onClose={() => onClose()} maxWidth="md" fullWidth>
      <DialogTitle>
        Edit · <span style={{ fontFamily: "monospace" }}>{name}</span>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          size="small"
          label="Dependencies (space-separated; installed with uv pip)"
          placeholder="torch diffusers transformers"
          value={packages}
          onChange={(e) => setPackages(e.target.value)}
          helperText="Rebuild the venv after changing these. Empty = no venv (e.g. echo)."
          sx={{ mb: 1.5 }}
          InputProps={{ sx: { fontFamily: "monospace", fontSize: ".85rem" } }}
        />
        <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, overflow: "hidden" }}>
          <CodeMirror value={code} height="320px" extensions={[python()]} onChange={(v) => setCode(v)} />
        </Box>
        {log && (
          <Accordion sx={{ mt: 1.5, boxShadow: "none", border: "1px solid", borderColor: "divider" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography color="text.secondary" variant="body2">
                venv build log
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                component="pre"
                sx={{
                  fontFamily: "monospace",
                  fontSize: ".8rem",
                  whiteSpace: "pre-wrap",
                  maxHeight: 160,
                  overflow: "auto",
                  m: 0,
                }}
              >
                {log}
              </Box>
            </AccordionDetails>
          </Accordion>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="inherit">
          Close
        </Button>
        <Button onClick={() => save(true)} disabled={busy} variant="outlined">
          Save + rebuild venv
        </Button>
        <Button onClick={() => save(false)} disabled={busy} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
